<template>
  <div class="form">
      <form>
        <h2>Wenst u een vrijblijvende offerte?</h2>
        <div class="input-container">
          <img src="@/assets/img/name.png"/>
          <input class="input-field" type="text" placeholder="Naam" name="naam">
        </div>
        <div class="input-container">
          <img src="@/assets/img/email.png"/>
          <input class="input-field" type="email" placeholder="Email" name="email">
        </div>
        <div class="input-container">
          <img src="@/assets/img/exclamation.png"/>
          <input class="input-field" type="text" placeholder="Onderwerp" name="onderwerp">
        </div>
        <div class="input-container">
          <img class="correction" src="@/assets/img/message.png"/>
          <textarea rows="4" class="input-field big" type="text" placeholder="Bericht" name="bericht"/>
        </div>
        <div class="input-container">
          <button type="submit">Verzenden!</button>
        </div>
      </form>
    </div>
</template>
<script>
export default {
  name: 'ContactForm'
}
</script>
<style lang="scss" scoped>
  .form {
    //margin-bottom: 2%;
    form {
      width: 98%;
      padding-top: 10px;
      padding-bottom: 10px;
      //margin-left: 5%;
      // padding-top: 10px;
      // padding-bottom: 10px;
      height: 500px;
      border: 2px solid lightgray;
      h2 {
        text-align: left;
        //width: 80%;
        margin-bottom: 2%;
        margin-left: 4%;
        font-size: 40px;
        //padding: 2px;
      }
    }
  }

  .input-container {
    width: 98%;
    position: relative;
    //padding: 5px;
    margin-left: 1%;
    margin-bottom: 1%;
    .input-field {
      //text-indent: 50px;
      font-size: 18px;
      padding: 18px;
      width: 85%;
      //margin-right: 5%;
      border-color: darkgray;
      padding-left: 70px;
    }
    .input-field:hover {
      border-color: orange;
    }
    .input-field:focus {
      border-color: orange;
    }
    img {
      position: absolute;
      left: 4%;
      bottom: 10%;
    }
    .correction {
      position: absolute;
      bottom: 30%;
    }
    button {
        width: 94%;
        padding: 16px;
        background: lightgray;
        border: 2px solid black;
        //margin-left: 5%;
      }
      button:hover {
        background: rgb(46, 45, 45);
        color: orangered;
        border: 2px solid orangered;
        cursor: pointer;
      }
  }

  @media screen and (min-width: 750px) and (max-width: 1450px) {
    .input-container {
      img {
        left: 3%;
      }
    }
  }

// }

  @media screen and (max-width: 750px) {
    .input-container {
      .input-field {
      //text-indent: 50px;
      font-size: 14px;
      padding: 10px;
      width: 75%;
      //margin-right: 5%;
      border-color: darkgray;
      padding-left: 50px;
      }

      img {
        position: absolute;
        left: 8%;
        bottom: 8%;
        width: 30px;
      }

      button {
        width: 85%;
      }
    }
  .form {
    form {
      height: 350px;
      h2 {
          font-size: 20px;
      }
    }
  }
}

</style>
